module.exports = "img/1.0ebb77.webp";